<div id="register-user-container">
    <div id="register-user-form-container">
        <!-- PIAS Logo -->
        <p>
            <img src="assets/images/PIAS-logo.png" alt="PIAS-logo" id="pias-logo" class="img img-fluid" />
        </p>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-1 col-xxl-1"></div>
            <div class="col-sm-12 col-md-12 col-lg-10 col-xxl-10">
                <div class="card">
                    <div class="card-body">
                        <p class="card-title mb-4 h4 text-start fw-bold">Register new user</p>
                        <mat-stepper [linear]="true" (selectedIndexChange)="onRegisterUserStepperIndexChange()"
                            (selectionChange)="onRegisterUserStepperIndexChange()" #registerUserStepper>
                            <!-- Step 1: Request OTP Email -->
                            <mat-step [stepControl]="registerUserFg">
                                <form [formGroup]="registerUserFg" class="row justify-content-center">
                                    <ng-template matStepLabel>Register User</ng-template>
                                    <p class="col-12">Please enter your email, if the email is valid & exists, we will
                                        send you the OTP.</p>
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xxl-5">
                                        <div class="row justify-content-center">
                                            <p class="col-12">
                                                <mat-form-field class="w-100">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput type="email" formControlName="email" required />
                                                    @if(this.registerUserFg.controls["email"].invalid
                                                    && (this.registerUserFg.controls["email"].touched ||
                                                    this.registerUserFg.controls["email"].dirty)
                                                    ) {
                                                    <mat-error>
                                                        @if(this.registerUserFg.controls["email"].errors?.["required"])
                                                        {
                                                        <span>Email is required.</span>
                                                        }
                                                        @else if
                                                        (this.registerUserFg.controls["email"].errors?.["email"])
                                                        {
                                                        <span>Enter a valid email address.</span>
                                                        }
                                                        @else if
                                                        (this.registerUserFg.controls["email"].errors?.["pattern"])
                                                        {
                                                        <span>Inavlid email pattern.</span>
                                                        }
                                                        @else {
                                                        <span></span>
                                                        }
                                                    </mat-error>
                                                    }
                                                </mat-form-field>
                                            </p>
                                            <p class="col-sm-12 col-md-12 col-lg-4 col-xxl-4">
                                                <button type="submit" class="btn-pias" (click)="this.__registerUser()"
                                                    [disabled]="this.registerUserFg.invalid">Send
                                                    OTP</button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </mat-step>
                            <!-- Step 2: Verify OTP -->
                            <mat-step [stepControl]="verifyOtpFg">
                                <form [formGroup]="verifyOtpFg" class="row justify-content-center">
                                    <ng-template matStepLabel>Verify OTP</ng-template>
                                    <p class="col-12">Enter the OTP you received to the given email.</p>
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xxl-5">
                                        <div class="row justify-content-center">
                                            <p class="col-12">
                                                <mat-form-field class="w-100">
                                                    <mat-label>OTP</mat-label>
                                                    <input matInput formControlName="otp" maxlength="6"
                                                        (keyup.enter)="this.__verifyOtp()" required NumbersOnlyInput />
                                                    @if(this.verifyOtpFg.controls["otp"].invalid
                                                    && (this.verifyOtpFg.controls["otp"].touched ||
                                                    this.verifyOtpFg.controls["otp"].dirty)
                                                    ) {
                                                    <mat-error>
                                                        @if(this.verifyOtpFg.controls["otp"].errors?.["required"]) {
                                                        <span>OTP is required.</span>
                                                        }
                                                        @else {
                                                        <span></span>
                                                        }
                                                    </mat-error>
                                                    }
                                                </mat-form-field>
                                            </p>
                                            <p class="col-sm-12 col-md-12 col-lg-4 col-xxl-4">
                                                <button type="submit" class="btn-pias" (click)="this.__verifyOtp()"
                                                    [disabled]="this.verifyOtpFg.invalid">Verify
                                                    OTP</button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                                <div class="row justify-content-center">
                                    <div class="col-md-3 col-lg-2 col-xxl-2 justify-content-center">
                                        <a class="pias-link d-flex align-items-middle justify-content-center"
                                            (click)="this.__resendOtp()">
                                            <mat-icon class="me-2">refresh</mat-icon>
                                            Resend code
                                        </a>
                                    </div>
                                </div>
                            </mat-step>
                            <!-- Step 3: Set new password -->
                            <mat-step [stepControl]="setNewPasswordFg">
                                <form [formGroup]="setNewPasswordFg" class="d-flex flex-column justify-content-center">
                                    <ng-template matStepLabel>Set new password</ng-template>
                                    <p class="text-center">Set your new password.</p>
                                    <div class="row justify-content-center">
                                        <div class="col"></div>
                                        <div class="col-sm-12 col-md-12 col-lg-10 col-xxl-8">
                                            <div class="row justify-content-center">
                                                <p class="col-md-12 col-lg-6">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>New Password</mat-label>
                                                        <input matInput [type]="newPasswordHide() ? 'password' : 'text'"
                                                            formControlName="newPassword"
                                                            (input)="this.__checkPasswordConstraints()"
                                                            (change)="this.__checkPasswordConstraintsError()"
                                                            required />

                                                        <button type="button" matIconButton matSuffix
                                                            (click)="newPasswordHideToggle($event)"
                                                            [attr.aria-label]="'Hide password'"
                                                            [attr.aria-pressed]="newPasswordHide()">
                                                            <mat-icon>{{newPasswordHide() ? 'visibility_off' :
                                                                'visibility'}}</mat-icon>
                                                        </button>
                                                        @if(this.setNewPasswordFg.controls["newPassword"].invalid
                                                        && (this.setNewPasswordFg.controls["newPassword"].touched ||
                                                        this.setNewPasswordFg.controls["newPassword"].dirty)
                                                        ) {
                                                        <mat-error>
                                                            @if(this.setNewPasswordFg.controls["newPassword"].errors?.["required"])
                                                            {
                                                            <span>Required.</span>
                                                            }
                                                            @else if(this.setNewPasswordFg.controls["newPassword"].errors?.["constraintError"])
                                                            {
                                                            <span>One or more constraints are not met.</span>
                                                            }
                                                            @else {
                                                            <span></span>
                                                            }
                                                        </mat-error>
                                                        }
                                                    </mat-form-field>
                                                </p>
                                                <p class="col-md-12 col-lg-6 text-start">
                                                    <span class="hint-text text-dark">
                                                        <i class="bi bi-info-circle-fill"></i>
                                                        Must contain at least one:
                                                    </span><br>
                                                    <span [class]="this.doesPasswordHasUppercase.textClass">
                                                        <i [class]="this.doesPasswordHasUppercase.iconClass"></i>
                                                        Uppercase character [A-Z]
                                                    </span><br>
                                                    <span [class]="this.doesPasswordHasLowercase.textClass">
                                                        <i [class]="this.doesPasswordHasLowercase.iconClass"></i>
                                                        Lowercase character [a-z]
                                                    </span><br>
                                                    <span [class]="this.doesPasswordHasNumber.textClass">
                                                        <i [class]="this.doesPasswordHasNumber.iconClass"></i>
                                                        Number [0-9]
                                                    </span><br>
                                                    <span [class]="this.doesPasswordHasSplChar.textClass">
                                                        <i [class]="this.doesPasswordHasSplChar.iconClass"></i>
                                                        Special character [@,#,$,&,*]
                                                    </span><br>
                                                    <span [class]="this.doesPasswordHasMinLength.textClass">
                                                        <i [class]="this.doesPasswordHasMinLength.iconClass"></i>
                                                        Min. 8 character
                                                    </span><br>
                                                    <!-- @if(this.setNewPasswordFg.controls["newPassword"].dirty) {
                                                @if(this.doesPasswordHasUppercase()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Contains atleast one
                                                    uppercase character [A-Z]</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Contains atleast one
                                                    uppercase character [A-Z]</span>
                                                }

                                                @if(this.doesPasswordHasLowercase()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Contains atleast one
                                                    lowercase character [a-z]</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Contains atleast one
                                                    lowercase character [a-z]</span>
                                                }

                                                @if(this.doesPasswordHasNumber()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Contains atleast one
                                                    numeric [0-9]</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Contains atleast one
                                                    numeric [0-9]</span>
                                                }

                                                @if(this.doesPasswordHasSplChar()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Contains atleast one
                                                    special character [@,#,$,&,*]</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Contains atleast one
                                                    special character [@,#,$,&,*]</span>
                                                }

                                                @if(this.doesPasswordHasMinLength()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Should have atleast 8
                                                    characters</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Should have atleast 8
                                                    characters</span>
                                                }
                                                } -->
                                                </p>
                                            </div>

                                            <div class="row justify-content-center">
                                                <p class="col-md-12 col-lg-6">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Confirm Password</mat-label>
                                                        <input matInput
                                                            [type]="confirmPasswordHide() ? 'password' : 'text'"
                                                            formControlName="confirmPassword"
                                                            (input)="this.__confirmPasswordMatch()"
                                                            (change)="this.__checkConfirmPasswordConstraintsError()"
                                                            required />

                                                        <button type="button" matIconButton matSuffix
                                                            (click)="confirmPasswordHideToggle($event)"
                                                            [attr.aria-label]="'Hide password'"
                                                            [attr.aria-pressed]="confirmPasswordHide()">
                                                            <mat-icon>{{confirmPasswordHide() ? 'visibility_off' :
                                                                'visibility'}}</mat-icon>
                                                        </button>
                                                        @if(this.setNewPasswordFg.controls["confirmPassword"].invalid
                                                        && (this.setNewPasswordFg.controls["confirmPassword"].touched ||
                                                        this.setNewPasswordFg.controls["confirmPassword"].dirty)
                                                        ) {
                                                        <mat-error>
                                                            @if(this.setNewPasswordFg.controls["confirmPassword"].errors?.["required"])
                                                            {
                                                            <span>Required.</span>
                                                            }
                                                            @else if(this.setNewPasswordFg.controls["confirmPassword"].errors?.["passwordNotMatchError"])
                                                            {
                                                            <span>Password does not match.</span>
                                                            }
                                                            @else if(this.setNewPasswordFg.controls["confirmPassword"].errors?.["constraintError"])
                                                            {
                                                            <span>One or more constraints are not met.</span>
                                                            }
                                                            @else {
                                                            <span></span>
                                                            }
                                                        </mat-error>
                                                        }
                                                    </mat-form-field>
                                                </p>
                                                <p class="col-md-12 col-lg-6 text-start">
                                                    <span class="hint-text text-dark">
                                                        <i class="bi bi-info-circle-fill"></i>
                                                        Must:
                                                    </span><br>
                                                    <span [class]="this.doesConfirmPasswordMatches.textClass">
                                                        <i [class]="this.doesConfirmPasswordMatches.iconClass"></i>
                                                        New and confirm password must match
                                                    </span><br>

                                                    <!-- @if(this.isNewPasswordEmpty()) {
                                                <span [class]="this.doesNewPasswordEmpty.textClass">
                                                    <i [class]="this.doesNewPasswordEmpty.iconClass"></i>
                                                    New password cannot be empty
                                                </span><br>
                                                } -->

                                                    <!-- @if(this.setNewPasswordFg.controls["confirmPassword"].dirty) {
                                                @if(this.doesConfirmPasswordMatches()) {
                                                <span
                                                    class="text-success hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-check-circle-fill me-1"></i>Password matches</span>
                                                }
                                                @else {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>Password does not
                                                    match</span>
                                                }

                                                @if(this.isNewPasswordEmpty()) {
                                                <span
                                                    class="text-danger hint-text text d-flex align-items-middle justify-content-start"><i
                                                        class="bi bi-x-circle-fill me-1"></i>New password field
                                                    cannot be empty</span>
                                                }
                                                } -->
                                                </p>
                                            </div>

                                            <div class="row justify-content-center">
                                                <p class="col-6">
                                                    <button type="submit" class="btn-pias"
                                                        (click)="this.__setNewPassword()"
                                                        [disabled]="this.setNewPasswordFg.invalid">Submit</button>
                                                </p>
                                                <p class="col-6"></p>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </mat-step>
                        </mat-stepper>
                        <div class="w-100 mt-4 row">
                            @if (canShowBanButton()) {
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xxl-2">
                                <button type="button" class="btn-pias mt-1" [disabled]="isBackBtnDisabled()"
                                    (click)="this.__backBtnAction()">Back</button>
                            </div>
                            }
                            <p class="col-sm-12 col-md-12 col-lg-2 col-xxl-2">
                                <button [routerLink]="'/login'" type="button" class="btn-pias mt-1">Cancel</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-1 col-xxl-1"></div>
        </div>

        <!-- Footer -->
        <div id="pias-footer">
            <p>© 2025 Professional Investment Advisory Services Pte Ltd</p>
        </div>
    </div>
</div>